(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crewready-discount-reminder"] && !Shopify.designMode) return;
  try {
    (() => {
    const reminders = document.querySelectorAll('[data-crewready-discount]');

    reminders.forEach((reminder) => {
      if (reminder.dataset.crewreadyCopyReady === 'true') return;

      const button = reminder.querySelector('[data-crewready-copy-code]');
      const status = reminder.querySelector('[data-crewready-copy-status]');
      if (!button || !status) return;

      reminder.dataset.crewreadyCopyReady = 'true';
      const code = button.dataset.crewreadyCopyCode;
      const readyText = status.textContent.trim();
      const copiedText = button.dataset.crewreadyCopiedText;

      const fallbackCopy = () => {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        return copied;
      };

      const showCopied = () => {
        status.textContent = copiedText;
        button.classList.add('is-copied');
        window.setTimeout(() => {
          status.textContent = readyText;
          button.classList.remove('is-copied');
        }, 2000);
      };

      button.addEventListener('click', async () => {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
            showCopied();
            return;
          }

          if (fallbackCopy()) showCopied();
        } catch (error) {
          if (fallbackCopy()) showCopied();
        }
      });
    });
  })();

  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let scheduled = false;

    const collectRoots = () => {
      const roots = [document];

      document.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });

      return roots;
    };

    const fixedAncestor = (element) => {
      let current = element;

      while (current && current !== document.body) {
        if (window.getComputedStyle(current).position === 'fixed') return current;
        current = current.parentElement || current.getRootNode().host;
      }

      return null;
    };

    const moveRewardsLauncher = () => {
      scheduled = false;
      if (!mobileQuery.matches) return;

      const candidates = [];

      collectRoots().forEach((root) => {
        root.querySelectorAll('button, a, div').forEach((element) => {
          if (element.textContent.trim() !== 'Rewards') return;

          const launcher = fixedAncestor(element);
          if (!launcher || candidates.includes(launcher)) return;

          const bounds = launcher.getBoundingClientRect();
          const isLauncherSize = bounds.width >= 70 && bounds.width <= 360 && bounds.height >= 40 && bounds.height <= 150;
          const isNearBottom = bounds.bottom >= window.innerHeight * 0.65;

          if (isLauncherSize && isNearBottom) candidates.push(launcher);
        });
      });

      candidates.forEach((launcher) => {
        launcher.style.setProperty('bottom', 'calc(88px + env(safe-area-inset-bottom))', 'important');
        launcher.dataset.crewreadyMobileOffset = 'true';
      });
    };

    const scheduleMove = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(moveRewardsLauncher);
    };

    const observer = new MutationObserver(scheduleMove);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    mobileQuery.addEventListener('change', scheduleMove);
    window.addEventListener('resize', scheduleMove, { passive: true });
    scheduleMove();
  })();
  } catch(e) { console.error(e); }
})();

})();
